import React, { FC } from "react";

import { KpkApiPublicShareExportDefinition } from "@keepeek/api-client";
import { useBasketShare } from "@keepeek/commons";
import { KModalContentSection, Format } from "@keepeek/refront-components";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { KIcon } from "../../../components/common/KIcon";
import { configSectionComponentBasketSelector } from "../../../providers/config/selectors";

import { CommonBasketShareProps } from "./index";

const PublicShareExportDefinitions: FC<CommonBasketShareProps> = function ({
  basketId,
  sentryCallback,
  snackbarCallback,
}) {
  const { t } = useTranslation();
  const { displayBackofficeSharedBasket } = useRecoilValue(
    configSectionComponentBasketSelector,
  ) ?? {
    displayBackofficeSharedBasket: undefined,
  };
  const {
    exportDefinitions,
    publicShareLoading,
    setSelectedExportDefinition,
    basketMaxDownloadLevel,
  } = useBasketShare(
    displayBackofficeSharedBasket ?? false,
    basketId,
    sentryCallback,
    snackbarCallback,
  );
  return (
    <KModalContentSection
      title={t("basket.share.content.export-definitions.title")}
      description={t("basket.share.content.export-definitions.description")}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: (theme) => theme.spacing(1),
          justifyContent: "start",
        }}
      >
        {exportDefinitions.map((ed) => (
          <Format
            onClick={() => setSelectedExportDefinition(ed.id as KpkApiPublicShareExportDefinition)}
            loading={publicShareLoading}
            key={ed.id}
            format={ed}
            KIcon={KIcon}
          />
        ))}
      </Box>
      {basketMaxDownloadLevel === KpkApiPublicShareExportDefinition.None && (
        <Typography
          sx={{
            color: (theme) => theme.palette.warning.light,
            fontSize: "14px",
            marginTop: (theme) => theme.spacing(0.5),
          }}
        >
          {t("basket.share.content.export-definitions.no-rights.label")}
        </Typography>
      )}
      {basketMaxDownloadLevel === KpkApiPublicShareExportDefinition.Bd && (
        <Typography
          sx={{
            color: (theme) => theme.palette.warning.light,
            fontSize: "14px",
            marginTop: (theme) => theme.spacing(0.5),
          }}
        >
          {t("basket.share.content.export-definitions.bd-rights.label")}
        </Typography>
      )}
    </KModalContentSection>
  );
};

export default PublicShareExportDefinitions;
